// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MarkdownLinkExtended } from '../../../assets/icons/extended/markdown/markdown-link.svg?react';
import { createIcons } from '../../Icon';
const MarkdownLinkIcon = /* @__PURE__ */ createIcons('MarkdownLink', {
    extended: MarkdownLinkExtended
});
MarkdownLinkIcon.supportedTypes = ['extended'];
MarkdownLinkIcon.category = 'markdown';
export default MarkdownLinkIcon;
